<style src="./List.scss" lang="scss"></style>

<template src="./List.html"></template>

<script>
	import Teaser from '@/components/Teaser/Teaser';

	export default {
		props: {
			elements: Array,
			title: String,
			smaller: {
				type: Boolean,
				default: false
			},
			numbered: {
				validator: function(value) {
					return ['true', 'false'].indexOf(value) !== -1;
				}
			},
			orientation: {
				validator: function(value) {
					return ['horizontal', 'vertical'].indexOf(value) !== -1;
				}
			}
		},
		components: {
			'hp-teaser': Teaser
		}
	};
</script>
